module.exports = __webpack_public_path__ + "img/vu-logo.050a69e7.svg";